import { useRef } from 'react';
import { useRafCallback, useResizeObserver, useSafeState } from '..';
/**
 * Uses ResizeObserver to track element dimensions and re-render component when they change.
 *
 * @param enabled Whether resize observer is enabled or not.
 */
export function useMeasure(enabled) {
    if (enabled === void 0) { enabled = true; }
    var elementRef = useRef(null);
    var _a = useSafeState(), rect = _a[0], setRect = _a[1];
    var observerHandler = useRafCallback(function (entry) {
        return setRect(entry.contentRect);
    })[0];
    useResizeObserver(elementRef, observerHandler, enabled);
    return [rect, elementRef];
}
